
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.122.021L0 2.143l5.305 5.303L.001 12.75l2.122 2.122 5.302-5.305 5.303 5.304 2.122-2.121-5.305-5.303 5.304-5.303L12.727.021 7.425 5.326 2.122.021z","fill":"#fff"}})])
          )
        }
      }
    